import React from "react";
import uniqid from "uniqid";
import { useAppSelector } from "../../../Store";
import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";
import AppMessageBoxWrapper from "../UtilsComponents/AppMessageBoxWrapper";
import AppTyping from "../UtilsComponents/AppTyping";

interface Props {
  [otherProps: string]: any;
}
const AppRenderTypingIndicator: React.FC<Props> = React.memo(() => {
  const { typingStatus, allMessages } = useAppSelector(allMessagesStore);
  // A reply being typed out live shows itself; the dots are only for the wait.
  const lastMessage = allMessages?.[allMessages.length - 1];

  if (!typingStatus || (lastMessage?.isStreaming && lastMessage?.value)) {
    return null;
  }

  return (
    <AppMessageBoxWrapper userMessage={false} key={uniqid()}>
      <AppTyping />
    </AppMessageBoxWrapper>
  );
});

export default AppRenderTypingIndicator;
